import posthog from 'posthog-js';
import { PostHogProvider as Provider } from 'posthog-js/react';

type Props = {
  children: React.ReactNode;
};

const postHogKey = import.meta.env.VITE_POSTHOG_KEY;
const postHogHost = import.meta.env.VITE_POSTHOG_HOST;

// Only initialize PostHog if the key and host are defined
if (postHogKey && postHogHost) {
  posthog.init(postHogKey, { api_host: postHogHost });
} else {
  console.warn('PostHog not initialized: missing key or host');
}

export const PostHogProvider = ({ children }: Props) => (
  <Provider client={posthog}>{children}</Provider>
);
